<div class="footer-menu-left">
  <span>Version: {{ version_short }}</span>
  <span id="infoVersion" class="info-popover dx-icon-info">
    <dx-popover target="#infoVersion" position="bottom" [width]="220" showEvent="dxclick" [hideEvent]="{ name: 'mouseleave', delay: 700 }">
      <div class="popover-padding">{{'versionNumber' | translate}} {{ version_full }}</div>
    </dx-popover>
  </span>
</div>

<dx-menu
  class="footer-menu-center"
  #menu1
  [dataSource]="menuitems"
  displayExpr="text"
  orientation="horizontal"
  submenuDirection="auto"
  (onItemClick)="onMenuItemClick($event)"
>
</dx-menu>

<div class="footer-menu-right">
  <div class="footer-menu-right-copyright"><a href="http://www.computerzentrum.de" target="_blank">Computer Zentrum Strausberg</a></div>
</div>
